import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ambientApi } from 'src/services';

export type UseGeneratePreChartSummaryPayload = {
  encounterId: string;
  clinicalNoteId?: string;
};

export const useGeneratePreChartSummary = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['generatePreChartSummary'],
    mutationFn: (payload: UseGeneratePreChartSummaryPayload) =>
      ambientApi
        .post(`/prechart/generate`, {
          encounter_id: payload.encounterId,
          clinical_note_id: payload.clinicalNoteId,
        })
        .then((res) => res.data),
    onSuccess: (_, payload) => {
      queryClient.invalidateQueries({
        queryKey: ['encounterDetails', payload.encounterId],
      });
      queryClient.invalidateQueries({
        queryKey: ['summaryList'],
      });
    },
  });
};
